import React, { ChangeEvent, useEffect, useRef, useState } from "react";
// import { IMaskInput } from 'react-imask';
import { IMaskInput } from "../ReactImask";
import { InputProps } from "./Input.types";
import "./Input.scss";
import IMask from "imask";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import i18next from 'i18next';

import PasswordHideIcon from "./assets/passwordhide.svg";
import calendarIcon from "./assets/calendaricon.svg";

export const leadingZeros = (number: number, zeros: number) => {
    return ("000000000000000000000000000000000000000000".substring(0, zeros - String(number).length)) + number;
  };

  export const formatShortDate = (date: Date) => {
    if (!date) return "";
    if (!(date instanceof Date)) date = new Date(date);
    return leadingZeros(date.getDate(), 2) + "/" + leadingZeros(date.getMonth() + 1, 2) + "/" + leadingZeros(date.getFullYear(), 4);
  };

  export const parseDate = (date: string) => {
    let m = /^(\d{2,2})\/(\d{2,2})\/(\d{4,4})$/.exec(date);
    if (m) {
      //@ts-ignore
      return new Date(m[3], m[2] - 1, m[1]);
    }
    m = /^(\d{2,2})\.(\d{2,2})\.(\d{4,4})$/.exec(date);
    if (m) {
      //@ts-ignore
      return new Date(m[3], m[2] - 1, m[1]);
    }
    m = /^(\d{4,4})-(\d{2,2})-(\d{2,2})$/.exec(date);
    if (m) {
      //@ts-ignore
      return new Date(m[1], m[2] - 1, m[3]);
    }
    return new Date(date);
  };

const importValue = (type: any, value: any) => value && type == "date" ? formatShortDate(value instanceof Date ? value : new Date(value)) : (value ? String(value) : "");

export const Input: React.FC<InputProps> = ({
    label,
    type,
    required,
    placeholder,
    value,
    error = false,
    errorMessage,
    icon,
    iconActive,
    iconClass,
    customClass,
    checked,
    disabled,
    name,
    mask,
    tabIndex,
    onTextChange,
    onkeypress,
    onBlur,
    min,
    max,
    step,
}) => {
    const [inputValue, setInputValue] = useState<string>(importValue(type, value));
    const [inputType, setInputType] = useState<string>(type == "date" ? "text" : type);
    const [className, setClassName] = useState<string>("");
    const [IMaskInstance, setIMaskInstance] = useState<any>(null);
    const [calendarVisible, showCalendar] = useState<boolean>(false);

    const handleChange = type != "date" ? (e: ChangeEvent<HTMLInputElement>) => {
        // console.log("CHANGED", e.target.value);
        //        setInputValue(e.target.value);
        if (onTextChange) {
            onTextChange(e);
        }
    } : () => { };

    const clickIcon = () => {
        // console.log("CLICK ICON");
        if (type === "password" && inputType === "password") {
            setInputType("text");
        } else {
            setInputType(type == "date" ? "text" : type);
        }
    };

    useEffect(() => {
        setInputValue(importValue(type, value));
    }, [value]);

    useEffect(() => {
        let IMaskOptions: any = null;
        if (type == "date" && !mask) {
            mask = {
                mask: Date,
                pattern: "d/`m/`Y",
                blocks: {
                    d: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 31,
                        maxLength: 2,
                    },
                    m: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 12,
                        maxLength: 2,
                    },
                    Y: {
                        mask: IMask.MaskedRange,
                        from: 1900,
                        to: 9999,
                    }
                },
                lazy: true,
                format: formatShortDate,
                // define str -> date convertion
                parse: parseDate,
            };
        }
        if (mask !== undefined) {
            if (typeof mask == "string") {
                switch (mask) {
                    case "amount":
                    case "percent":
                        IMaskOptions = {
                            mask: Number,
                            scale: 8,
                            signed: false,
                            thousandsSeparator: ",",
                            padFractionalZeros: false,
                            radix: ".",
                            // mapToRadix: [',']
                        };
                        // console.log("MASK", IMaskOptions);
                        break;
                    case "price":
                        IMaskOptions = {
                            mask: Number,
                            scale: 4,
                            signed: false,
                            thousandsSeparator: ",",
                            padFractionalZeros: false,
                            radix: ".",
                            // mapToRadix: [',']
                        };
                        break;
                    case "cryptoprice":
                        IMaskOptions = {
                            mask: Number,
                            scale: 8,
                            signed: false,
                            thousandsSeparator: ",",
                            padFractionalZeros: false,
                            radix: ".",
                            // mapToRadix: [',']
                        };
                        break;
                    case "integer":
                        IMaskOptions = {
                            mask: Number,
                            scale: 0,
                            signed: false,
                            thousandsSeparator: ",",
                        };
                        break;
                    default:
                        IMaskOptions = { mask: mask };
                }
            } else {
                IMaskOptions = mask;
            }
        }
        if (IMaskOptions && inputRef.current) {
            if (!IMaskInstance) {
                const instance = IMask(inputRef.current, IMaskOptions);
                if (type == "date") {
                    instance.on("accept", (e: any) => {
                        //console.log("ACCEPT",instance.value);
                        setInputValue(instance.value);
                    });
                    instance.on("complete", (e: any) => {
                        // console.log("COMPLETE", instance.value);
                        // setInputValue(instance.value);
                        if (onTextChange) {
                            onTextChange({
                                target: {
                                    name: name,
                                    value: parseDate(instance.value),
                                },
                            });
                        }
                    });
                }
                // console.log("CREATE INSTANCE",IMaskOptions);
                else {
                    instance.on("accept", (e: any) => {
                        // console.log("ACCEPT",instance.value,value);
                        setInputValue(instance.value);
                        if (onTextChange) {
                            onTextChange({
                                target: {
                                    name: name,
                                    value: instance.value,
                                },
                            });
                        }
                    });
                }
                setIMaskInstance(instance);
            }
        } else {
            if (IMaskInstance) {
                IMaskInstance.destroy();
                setIMaskInstance(null);
            }
        }
        //setInputType(type);
    }, [mask]);

    useEffect(() => {
        if (type == "date") {
            if (inputValue.length === 0) {
                setClassName(`${customClass} date-empty`);
            } else {
                setClassName(`${customClass} date-full`);
            }
        } else {
            setClassName(customClass ? customClass : "");
        }
    }, [inputValue]);

    const getActiveIcon = () => {
        if (type === "password" && inputType === "text") {
            return (
                <img
                    onClick={() => clickIcon()}
                    src={PasswordHideIcon}
                    className={`icon ${iconClass ? iconClass : ""}`}
                />
            );
        } else {
            if (iconActive) {
                return (
                    <img
                        onClick={() => clickIcon()}
                        src={iconActive}
                        className={`icon ${iconClass ? iconClass : ""}`}
                    />
                );
            } else {
                return null;
            }
        }
    };
    const clickCalendar = () => showCalendar(!calendarVisible);
    const hideCalendar = () => showCalendar(false);
    const calendarChange = (value: Date) => {
        //@ts-ignore
        setInputValue(formatShortDate(value));
        showCalendar(false);
        if (onTextChange) {
            onTextChange({
                target: {
                    name: name,
                    value: value,
                },
            });
        }
    };

    // if (name=="price")
    // console.log("RENDER VALUE",name,value);

    const inputRef = useRef<HTMLInputElement>(null);
    return (
        <div className={"input-wrapper"}>
            {label && (
                <label htmlFor={"input-general"}>
                    {required && "*"} {label}
                </label>
            )}
            <div className={"input-content"}>
                {/*{type === 'date' && <img src={CalendarIcon} className={"icon"}/>}*/}
                {icon && inputValue.length == 0 ? (
                    <img
                        onClick={() => clickIcon()}
                        src={icon}
                        className={`icon ${iconClass ? iconClass : ""}`}
                    />
                ) : type == "date" && (
                    <img
                        onClick={() => clickCalendar()}
                        src={calendarIcon}
                        className={`icon ${iconClass ? iconClass : ""}`}
                    />
                )}

                {inputValue.length > 0 && getActiveIcon()}
                <input
                    ref={inputRef}
                    min={min}
                    max={max}
                    step={step}
                    onKeyPress={onkeypress}
                    type={inputType}
                    className={error ? `input-error ${className}` : `${className}`}
                    disabled={disabled}
                    id={"input-general"}
                    onChange={handleChange}
                    name={name}
                    placeholder={placeholder}
                    value={inputValue}
                    autoComplete="off"
                    tabIndex={tabIndex}
                    onBlur={onBlur}
                />
                {calendarVisible &&
                    <>
                        <div className="calendar-overlay" onClick={hideCalendar}></div>
                        <div className="calendar-container">
                            <Calendar value={value ? parseDate(value) : null} onChange={calendarChange} calendarType="Hebrew" locale={i18next.language == "he" ? "he" : "us"} className="calendar-popup" />
                        </div>
                    </>}
            </div>
            {error && <p className={"error-message"}>{errorMessage}</p>}
        </div>
    );
};
